import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { addChecklistItem } from "../../../services/api/qa/checklistService";

function CreateChecklistItems() {
  const { id } = useParams(); // checklist id
  const navigate = useNavigate();

  const [items, setItems] = useState([
    {
      check_point: "",
      type: "pass_fail",
      is_required: true,
    },
  ]);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // Handle change
  const handleChange = (index, field, value) => {
    const updated = [...items];
    updated[index][field] = value;
    setItems(updated);
  };

  // Add new row
  const addItem = () => {
    setItems([
      ...items,
      {
        check_point: "",
        type: "pass_fail",
        is_required: true,
      },
    ]);
  };

  // Remove row
  const removeItem = (index) => {
    if (items.length === 1) return;
    const updated = items.filter((_, i) => i !== index);
    setItems(updated);
  };

  // Validation
  const validate = () => {
    let newErrors = {};
    let itemErrors = [];

    items.forEach((item, index) => {
      if (!item.check_point.trim()) {
        itemErrors[index] = "Check point is required";
      }
    });

    if (itemErrors.length > 0) {
      newErrors.itemErrors = itemErrors;
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);

    try {
      // If backend supports single item API
      for (let item of items) {
        await addChecklistItem(id, {
          check_point: item.check_point.trim(),
          type: item.type,
          is_required: item.is_required,
        });
      }

      navigate("/checklist");
    } catch (error) {
      console.error(error);
      setErrors({ general: "Failed to save checklist items" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-6">
        Add Checklist Items
      </h2>

      {errors.general && (
        <p className="text-red-500 mb-4">{errors.general}</p>
      )}

      <form onSubmit={handleSubmit}>
        {items.map((item, index) => (
          <div
            key={index}
            className="border p-4 rounded mb-4 bg-gray-50"
          >
            <div className="mb-3">
              <label className="block text-sm font-medium mb-1">
                Check Point
              </label>
              <input
                type="text"
                className="border w-full p-2 rounded"
                value={item.check_point}
                onChange={(e) =>
                  handleChange(index, "check_point", e.target.value)
                }
              />
              {errors.itemErrors && errors.itemErrors[index] && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.itemErrors[index]}
                </p>
              )}
            </div>

            <div className="mb-3">
              <label className="block text-sm font-medium mb-1">
                Type
              </label>
              <select
                className="border w-full p-2 rounded"
                value={item.type}
                onChange={(e) =>
                  handleChange(index, "type", e.target.value)
                }
              >
                <option value="pass_fail">Pass / Fail</option>
                <option value="text">Text</option>
                <option value="number">Number</option>
              </select>
            </div>

            <div className="flex items-center gap-2 mb-3">
              <input
                type="checkbox"
                checked={item.is_required}
                onChange={(e) =>
                  handleChange(index, "is_required", e.target.checked)
                }
              />
              <label className="text-sm">Is Required</label>
            </div>

            <button
              type="button"
              onClick={() => removeItem(index)}
              disabled={items.length === 1}
              className={`px-3 py-1 rounded ${
                items.length === 1
                  ? "bg-gray-200 cursor-not-allowed"
                  : "bg-red-100 text-red-600"
              }`}
            >
              Remove
            </button>
          </div>
        ))}

        <button
          type="button"
          onClick={addItem}
          className="text-blue-600 mb-6"
        >
          + Add Item
        </button>

        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="border px-4 py-2 rounded"
          >
            Back
          </button>

          <button
            type="submit"
            className="bg-blue-600 text-white px-4 py-2 rounded"
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Items"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default CreateChecklistItems;